import { runtimeEnv } from '../runtimeEnv';
import { hasPreviewCookie } from './preview';
import { hubLdContext } from './ldContext';

// With `bootstrap: 'localStorage'` (src/main.tsx) the LaunchDarkly SDK keeps the flags of its last
// evaluation under `ld:<client-side id>:<base64 of the context JSON>`, each as `{ value, version }`
// (or a bare value in its pre-schema format), and serves them before the network answers.
export function ldCacheKey(clientId: string, context: object): string {
  const bytes = new TextEncoder().encode(JSON.stringify(context));
  return `ld:${clientId}:${btoa(String.fromCodePoint(...bytes))}`;
}

// Pure: whether this browser's cached evaluation for the context already holds `flagKey` as true.
// Anything missing or unreadable is false, i.e. the flag's in-code default.
export function readCachedFlag(
  storage: Pick<Storage, 'getItem'>, clientId: string, context: object, flagKey: string,
): boolean {
  try {
    const raw = storage.getItem(ldCacheKey(clientId, context));
    if (!raw) return false;
    const entry: unknown = (JSON.parse(raw) as Record<string, unknown> | null)?.[flagKey];
    const value = typeof entry === 'object' && entry !== null && 'value' in entry ? entry.value : entry;
    return value === true;
  } catch {
    return false;
  }
}

// Thin glue: `release-hub-trial-auto-start` as LaunchDarkly will first serve it in this browser.
export function trialAutoStartCachedOn(): boolean {
  try {
    const context = hubLdContext(hasPreviewCookie(document.cookie));
    return readCachedFlag(localStorage, runtimeEnv.ldClientId, context, 'release-hub-trial-auto-start');
  } catch {
    return false;
  }
}
